<div class='apps-grid-wrapper'>
  <kendo-grid class="apps-grid" [data]="view" [sort]="state.sort" [sortable]="true" [filter]="state.filter" filterable="menu"
    [scrollable]="'virtual'" [rowHeight]="32" [detailRowHeight]="60" [resizable]="true" (dataStateChange)="dataStateChange($event)"
    [skip]="state.skip"
    [pageSize]="state.take"
    [groupable]="false"
    [group]="groups"
    (groupChange)="groupChange($event)"

    #grid>
    <!-- <kendo-grid-checkbox-column [width]="8" [style]="{'max-width':'8px', 'min-width':'8px', 'padding':'4px 4px'}" [headerStyle]="{'max-width':'8px', 'padding':'4px 4px'}"></kendo-grid-checkbox-column> -->
    <kendo-grid-column field="displayName" title="Display Name" [width]="160" class="cell">
      <ng-template kendoGridGroupHeaderTemplatе let-aggregates>
        Sum: {{aggregates["createdByDisplayName"].count}}
      </ng-template>
      <ng-template kendoGridHeaderTemplate let-column>
        <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div style="display: flex; justify-content: stretch;">
          <img [src]="this.getSafeUrl(dataItem.backgroundImageUri)" [style.background-color]="dataItem.backgroundColor" style="height:20px; width:20px; vertical-align: middle; align-self:flex-start;">&nbsp;
          <span style="align-self:flex-start; justify-self: stretch;">
            <a href="{{this.apiRoot}}/environments/{{dataItem.environmentName}}/apps/{{dataItem.name}}/details"
              title="Maker Portal: {{this.apiRoot}}/environments/{{dataItem.environmentName}}/apps/{{dataItem.name}}/details" target="_blank">
              <span style="margin-right: 5px;" [style.text-decoration]="dataItem.flowState=='Deleted'? 'line-through': ''">{{dataItem.displayName}}</span>
            </a>
          </span>
          <span style="align-self:flex-end;">
            <a href="{{this.apiRoot}}/environments/{{dataItem.environmentName}}/apps/{{dataItem.name}}/details"
              title="Maker Portal: /environments/{{dataItem.environmentName}}/apps/{{dataItem.name}}" target="_blank">
              <i class="ms-Icon ms-Icon--Edit hover-only" style='font-weight:bold; margin-right: 5px;' aria-hidden="true"></i>
            </a>
            <a href="https://apps.powerapps.com/play/{{dataItem.name}}"
              title="Maker Portal: /environments/{{dataItem.environmentName}}/apps/{{dataItem.name}}" target="_blank">
              <i class="ms-Icon ms-Icon--Play hover-only" style='font-weight:bold; margin-right: 5px;' aria-hidden="true"></i>
            </a>
            <!-- <i class="ms-Icon ms-Icon--More hover-only" style='font-weight:bold; cursor: pointer;' aria-hidden="true" (click)="reContextMenu($event)" title="More Commands"></i> -->
          </span>
        </div>
      </ng-template>
      <ng-template kendoGridFooterTemplate let-column="column">
        <span title='Total PowerApps'>{{this.items.length}}&nbsp;</span>
        <span class='ms-Icon ms-Icon--Refresh' title='click to reload runs' (click)='this.reload()' style="cursor: pointer;" ></span>
        <!--<span>(cache:{{this.cache.flows}},{{this.cache.runs}}<span (click)='this.clearRuns()'>x</span>,{{this.cache.settings}})&nbsp;</span>-->
        <span style="margin-left: 6px;">{{ this.apiService.serviceStatus$ | async }}</span>

        @if (this.hasFilter) {
          <span title="click to clear filter" style="text-decoration: underline; cursor: pointer;" (click)="this.clearFilter()"><span class='ms-Icon ms-Icon--ClearFilter'></span> Results are filtered</span>
        }
      </ng-template>
    </kendo-grid-column>
    <!-- <kendo-grid-column field="runsSort" title="Runs" [width]="40" [minResizableWidth]="25" type="number" filter="number" filterable="false" class="cell" [style]="{'min-width': '40px', 'text-overflow': 'initial', 'overflow': 'hidden', 'cursor': 'pointer'}">
    <ng-template kendoGridHeaderTemplate let-column>
      <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-sparkline type="column" renderAs="canvas" (click)="doGetRuns(dataItem)">
        <kendo-chart-area background="transparent" [margin]="1">
        </kendo-chart-area>
        <kendo-chart-tooltip>
          <ng-template kendoChartSeriesTooltipTemplate let-value="value">
            duration: {{ value }}ms
          </ng-template>
        </kendo-chart-tooltip>
        <kendo-chart-series>
          <kendo-chart-series-item type="column" [data]="dataItem?.runsSparkline">
          </kendo-chart-series-item>
        </kendo-chart-series>
      </kendo-sparkline>
    </ng-template>
  </kendo-grid-column>     -->
  <!-- <kendo-grid-column field="tags" title="Tags" [width]="80" [minResizableWidth]="80" class="cell" [style]="{'min-width': '50px'}">
  <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
    <kendo-multiselect style="width:220px" [data]="flowTags" [valuePrimitive]="true" [value]="multiFilters(filter)"
      (valueChange)="multiChange($event, filterService, 'tags', 'contains')">
    </kendo-multiselect>
  </ng-template>
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <div *ngIf="this.bgColor(dataItem)" style="width:20px;height:20px;display:inline-block;vertical-align:middle; margin-right:3px;"
    [style.background-color]='this.bgColor(dataItem)'>&nbsp;</div>
    <span *ngFor="let tag of dataItem.tags" style='margin-right:5px;'><a class='flow-tag cell-filter' href='javascript:void(0)'
    (click)='this.filterByTag(tag)'>{{tag}}</a></span>
    <span class='k-icon k-i-plus-outline hover-only' style="margin-right: 5px; cursor: pointer;" (click)="doTags(dataItem)" title="Change Tags"></span>
  </ng-template>
</kendo-grid-column> -->
<kendo-grid-column field="ownerName" title="Owner" [width]="60" [minResizableWidth]="60" [style]="{'min-width': '60px'}">
  <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
    <kendo-multiselect style="width:220px" [data]="creators" [valuePrimitive]="true" [value]="multiFilters(filter)"
      [autoClose]="false"
      (valueChange)="multiChange($event, filterService, 'ownerName', 'eq')">
    </kendo-multiselect>
  </ng-template>
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <!-- <span *ngIf="dataItem.sharingType.includes('Coauthor')" class='ms-Icon ms-Icon--People' title='Team Flow'
  [ngStyle]="{'color': dataItem.userType == 'Owner' ? 'green': 'black' }"></span>
  <span *ngIf="dataItem.sharingType.includes('DelegatedAuth')" class='ms-Icon ms-Icon--PeopleExternalShare' title='Resource Owner'
  [ngStyle]="{'color': dataItem.userType == 'Owner' ? 'dodgerblue': 'black' }"></span>
  <fa-icon icon="folder-open" title="Solution Aware" *ngIf="dataItem.sharingType.includes('CommonDataService')" [ngStyle]="{'color': '#742873' }"></fa-icon> -->
  {{ dataItem.ownerName }}
</ng-template>
</kendo-grid-column>
<kendo-grid-column field="primaryFormFactor" title="Form" [width]="50" [minResizableWidth]="50" [style]="{'min-width': '50px'}">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
</kendo-grid-column>
<!-- <kendo-grid-column field="hasComponent" title="Component" [width]="50" [minResizableWidth]="50" [style]="{'min-width': '50px'}">
<ng-template kendoGridHeaderTemplate let-column>
  <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
</ng-template>
</kendo-grid-column> -->
<kendo-grid-column field="commitMessage" title="Message" [width]="50" [minResizableWidth]="50" [style]="{'min-width': '50px'}">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <div style="display: inline-block; text-overflow: ellipsis;" class='cell' title="{{dataItem.commitMessage}}">{{ dataItem.commitMessage }}</div>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="publisherVersion" title="PowerApps Release" [width]="50" [minResizableWidth]="50">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
</kendo-grid-column>
<!-- <kendo-grid-column field="flowState" title="State" [width]="30" [minResizableWidth]="30" [style]="{'min-width': '30px'}">
<ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
  <kendo-multiselect style="width:220px" [data]="flowStates" [valuePrimitive]="true" [value]="multiFilters(filter)"
    (valueChange)="multiChange($event, filterService, 'flowState', 'eq')">
  </kendo-multiselect>
</ng-template>
<ng-template kendoGridHeaderTemplate let-column>
  <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
</ng-template>
<ng-template kendoGridCellTemplate let-dataItem>

  <span *ngIf="dataItem.flowState=='Started'" class='cell cell-filter' style='color:green;'
    (click)='this.filterByFlowState(dataItem.flowState)' title='Started'>
    <i class="ms-Icon ms-Icon--PowerButton" style='font-weight:bold;' aria-hidden="true"></i>
  </span>
  <span *ngIf="dataItem.flowState=='Stopped'" class='cell cell-filter' style='color:gray'
    (click)='this.filterByFlowState(dataItem.flowState)' title='Stopped'>
    <i class="ms-Icon ms-Icon--Blocked2" style='font-weight:bold;' aria-hidden="true"></i>
  </span>
  <span *ngIf="dataItem.flowState=='Deleted'" class='cell cell-filter' style='color:red'
    (click)='this.filterByFlowState(dataItem.flowState)' title='Deleted'>
    <i class="ms-Icon ms-Icon--Blocked2" style='font-weight:bold;' aria-hidden="true"></i>
  </span>
</ng-template>
</kendo-grid-column> -->
<kendo-grid-column field="createdTime" title="Created" [width]="60" [minResizableWidth]="60" type="date" format="{0:y-MM-dd HH:mm}"
  filter="date" class="cell" [style]="{'min-width': '65px'}">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <span title="{{dataItem.runLast|date:'y-MM-dd HH:mm:ss a' }}">{{dataItem.createdTime|date:'y-MM-dd HH:mm'}}</span>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="modified" title="Last Modified" [width]="60" [minResizableWidth]="60" type="date" format="{0:y-MM-dd HH:mm}"
  filter="date" class="cell" [style]="{'min-width': '65px'}">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <span title="{{dataItem.modified|date:'y-MM-dd HH:mm:ss a' }}">{{dataItem.modified|date:'y-MM-dd HH:mm'}}</span>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="sharedUsersCount" title="Shared Users" [width]="35" [minResizableWidth]="35" type="number" filter="numeric"
  [filterable]="false" class="cell" [style]="{'min-width': '25px'}">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
</kendo-grid-column>
<kendo-grid-column field="sharedGroupsCount" title="Shared Groups" [width]="25" [minResizableWidth]="25" type="number" filter="numeric"
  [filterable]="false" [style]="{'min-width': '25px'}">
  <ng-template kendoGridHeaderTemplate let-column>
    <div style="display:inline-block;" title="{{column.title}}">{{column.title}}</div>
  </ng-template>
</kendo-grid-column>
<!-- <kendo-grid-column field="environment" title="Environment" [width]="60" [minResizableWidth]="60"
class="cell" [style]="{'min-width': '65px'}">
<ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
  <kendo-multiselect style="width:220px" [data]="flowEnvironments" [valuePrimitive]="true" [value]="multiFilters(filter)"
    (valueChange)="multiChange($event, filterService, 'environment', 'eq')">
  </kendo-multiselect>
</ng-template>
</kendo-grid-column> -->
<!-- <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="this.hasRuns">
<app-flow-runs [flow]="dataItem" [runs]="dataItem.runsLoaded" [nested]="true"></app-flow-runs>
</ng-template> -->
<kendo-grid-excel fileName="powerapps.xlsx"></kendo-grid-excel>
<ng-template kendoGridLoadingTemplate>
  <div class="k-loading-color"></div>
  <div class="loading-container">
    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
  </div>
</ng-template>
</kendo-grid>
<!-- <div *ngIf="!this.ready" class="k-i-loading"></div> -->
<!-- <grid-context-menu [for]="grid" [menuItems]="['Enable', 'Disable', 'Edit JSON']" (select)="onSelect($event)"></grid-context-menu> -->
</div>